import PropTypes from 'prop-types';
import React from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import Modal from 'brastrap/common/modal/Modal';
import Button from 'brastrap/common/button/Button';

const messages = defineMessages({
  close: { id: 'actions.close', defaultMessage: 'Close' },
});

const ModalButton = props => {
  const {
    button,
    modal,
    intl: { formatMessage },
    modalId,
  } = props;

  // Ensure the modal has a dismiss action which calls the close action
  modal.actions = {
    dismiss: {
      icon: {
        icon: 'dismiss',
        label: formatMessage(messages.close),
        labelled: 'after',
      },
      onClick: () => props.onModalClose(),
    },
  };

  return (
    <div className="c-modal--button">
      <Button
        id={modalId}
        modifiers={button.modifiers}
        label={button.label}
        onClick={() => props.onModalOpen(props.modalId)}
      />
      <Modal {...modal} modalId={props.modalId} isOpen={props.isOpen}>
        {props.children}
      </Modal>
    </div>
  );
};

const buttonPropTypes = {
  ...Button.propTypes,
};

delete buttonPropTypes.onClick;

ModalButton.propTypes = {
  button: PropTypes.shape(buttonPropTypes).isRequired,
  children: PropTypes.node,
  intl: intlShape,
  isOpen: PropTypes.bool,
  modalId: PropTypes.string,
  modal: PropTypes.shape(Modal.propTypes).isRequired,
  onModalOpen: PropTypes.func,
  onModalClose: PropTypes.func,
};

ModalButton.defaultProps = {
  onModalClose: () => {},
  onModalOpen: () => {},
};

export default injectIntl(ModalButton);
